import {MAIN_BANNER_CATEGORY} from '../../config/app';

const mapBannerData = (banners) => {
  return banners.map((banner) => ({
    img: banner.image.mobile_url,
    img_desktop: banner.image.desktop_url,
    img_desktop_login: banner.image.desktop_login_url,
    title: banner.description,
    url: banner.redirect_url,
    order: banner.order,
  }));
};

const initialState = {
  mainBanners: [],
};

const getters = {
  getBanners: (state, commit, rootState) => ({
    [MAIN_BANNER_CATEGORY]: mapBannerData(rootState.dataServer?.banners ?? []),
  }),
};

const actions = {};

const mutations = {};

export default {
  namespaced: true,
  state: {...initialState},
  getters,
  actions,
  mutations,
};
